import { render, staticRenderFns } from "./Text1.vue?vue&type=template&id=052c1ab9&scoped=true"
import script from "./Text1.vue?vue&type=script&lang=js"
export * from "./Text1.vue?vue&type=script&lang=js"
import style0 from "./Text1.vue?vue&type=style&index=0&id=052c1ab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052c1ab9",
  null
  
)

export default component.exports